const pageBackgroundItems = {
  imgSrc: '//raderain.sirv.com/devs/home/close-up-fiber-grey-home.jpg',
  alt: 'home banner image',
}

export { pageBackgroundItems }
